import { ROUTES } from "./constants";

export const DASHBOARD_SETTINGS = [
  {
    key: "programme_profile",
    label: "Programme Profile",
    path: ROUTES.ADMIN_DASHBOARD,
    description: "Participation and engagement overview for the programme.",
    aiSupported: false,
  },
  {
    key: "wellness_overview",
    label: "Wellness Overview",
    path: "/admin/wellness-overview",
    description: "Top-level wellness signals across the organisation.",
    aiSupported: false,
  },
  {
    key: "recovery",
    label: "Recovery",
    path: ROUTES.RECOVERY,
    description: "Recovery trends and distribution for the selected period.",
    aiSupported: false,
  },
  {
    key: "sleep_analytics",
    label: "Sleep Analytics",
    path: ROUTES.SLEEP_ANALYTICS,
    description: "Sleep performance, trends, and stage breakdowns.",
    aiSupported: false,
  },
  {
    key: "strain_activity",
    label: "Strain and Activity",
    path: ROUTES.STRAIN_AND_ACTIVITY,
    description: "Training load, activity balance, and heart rate zones.",
    aiSupported: false,
  },
  {
    key: "overall_stress_mind",
    label: "Overall Physiological Stress",
    path: "/admin/stress-mind",
    description: "Stress patterns and mental wellbeing indicators.",
    aiSupported: false,
  },
  {
    key: "biometrics_vitals",
    label: "Biometrics and Vitals",
    path: "/admin/biometrics",
    description: "Vitals trends for HRV, SpO2, temperature, and more.",
    aiSupported: false,
  },
  {
    key: "user_progress",
    label: "User Progress",
    path: "/admin/user-progress",
    description: "Individual progress trends and wellbeing dimensions.",
    aiSupported: true,
  },
  {
    key: "team_progress",
    label: "Team Progress",
    path: "/admin/team-progress",
    description: "Team-level progress and aggregated insights.",
    aiSupported: true,
  },
  {
    key: "jeopardy_insights",
    label: "Jeopardy Insights",
    path: ROUTES.JEOPARDY_INSIGHTS,
    description: "Risk breakdowns and at-risk user summaries.",
    aiSupported: false,
  },
  {
    key: "measure_comparison",
    label: "Measure Comparison",
    path: ROUTES.MEASURE_COMPARISON_INSIGHTS,
    description: "Compare metrics across groups or time.",
    aiSupported: false,
  },
  {
    key: "predictive_insights",
    label: "Predictive Insights",
    path: ROUTES.PREDICTIVE_INSIGHTS,
    description: "Model-driven outlooks for future wellbeing trends.",
    aiSupported: false,
  },
] as const;

export const DASHBOARD_PATH_TO_KEY = DASHBOARD_SETTINGS.reduce(
  (acc, dashboard) => {
    acc[dashboard.path] = dashboard.key;
    return acc;
  },
  {} as Record<string, (typeof DASHBOARD_SETTINGS)[number]["key"]>
);
